import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { requireCheckboxesToBeCheckedValidator } from 'src/app/Modules/idms/core/atleastOneChecked.validator';
// import { CUSTOM_DATE_FORMATS, CustomDateAdapter, ngxCUSTOM_DATE_FORMATS, ngxCustomDateAdapter } from 'src/app/Modules/idms/core/custom-date-adapter';
import { CompareDates } from 'src/app/Modules/settings/core/Validators/compare.Validator';
import { CommunicationType } from 'src/app/Modules/settings/enums/communication-type.enum';
import { Communication } from 'src/app/Modules/settings/models/profile/communication.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-add-update-communication',
    templateUrl: './add-update-communication.component.html',
    styleUrls: ['./add-update-communication.component.scss'],
    standalone: false,
})
export class AddUpdateCommunicationComponent implements OnInit {
    @Input() communication: Communication;
    @Input() modalType: number;
    @Input() isGeneralNotification: boolean;
    @Input() preCloseSaveHandler: (saveObj: any) => Promise<boolean> | boolean;

    now: Date = new Date();
    communicationPayload: Communication;
    currentCommunicationList: Communication[];
    message: string;
    communicationForm: UntypedFormGroup;
    currentDate = new Date();
    minEndDate: Date;
    public showSpinners = true;
    public showSeconds = true;
    public touchUi = false;
    public enableMeridian = false;
    public stepHour = 1;
    public stepMinute = 1;
    public stepSecond = 1;
    destroy$ = new Subject();
    characterCount: number = 0;
    constructor(
        public ngbModal: NgbModal,
        private formBuilder: UntypedFormBuilder,
        private globalEmittersService: GlobalEmittersService,
        private activeModel: NgbActiveModal,
        private customValidator: CustomValidatorService,
        private customToastService: CustomToastService
    ) {
        this.message = '';
    }

    ngOnInit(): void {
        this.initializeForm();
        this.globalEmittersService.communicationList.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.currentCommunicationList = res;
            }
        });
    }

    communicationHandler(content) {
        this.initializeForm();
        this.message = '';
        let dialogRef = this.ngbModal.open(content, {
            size: 'xl',
        });
        dialogRef.result
            .then((res) => {})
            .catch((err) => {
                console.warn(err);
            });
    }

    btnCancelClicked() {
        this.ngbModal.dismissAll(true);
    }

    // * initialize edit form
    initializeForm() {
        if (this.isGeneralNotification) {
            if (this.communication) {
                this.communicationForm = this.formBuilder.group({
                    title: [this.communication.title, [Validators.required]],
                    message: [this.communication.message || ''],
                    isSystemNotification: [false, []],
                    calender_group: new UntypedFormGroup(
                        {
                            startDate: new UntypedFormControl(new Date(this.communication.startDate), Validators.required),
                            endDate: new UntypedFormControl(new Date(this.communication.endDate), Validators.required),
                        },
                        CompareDates()
                    ),
                    checkbox_group: new UntypedFormGroup(
                        {
                            email: new UntypedFormControl(false, Validators.required),
                            mobile: new UntypedFormControl(false, Validators.required),
                            web: new UntypedFormControl(false, Validators.required),
                        },
                        requireCheckboxesToBeCheckedValidator()
                    ),
                });

                this.communication.notificationTypes.forEach((item) => {
                    if (item == CommunicationType.Email) {
                        this.communicationForm.get('checkbox_group').get('email').setValue(true);
                    } else if (item == CommunicationType.Mobile) {
                        this.communicationForm.get('checkbox_group').get('mobile').setValue(true);
                    } else {
                        this.communicationForm.get('checkbox_group').get('web').setValue(true);
                    }
                });
            } else {
                this.communicationForm = this.formBuilder.group({
                    title: ['', [Validators.required]],
                    message: [''],
                    isSystemNotification: [false, []],
                    calender_group: new UntypedFormGroup(
                        {
                            startDate: new UntypedFormControl('', Validators.required),
                            endDate: new UntypedFormControl('', Validators.required),
                        },
                        CompareDates()
                    ),
                    checkbox_group: new UntypedFormGroup(
                        {
                            email: new UntypedFormControl(false, Validators.required),
                            mobile: new UntypedFormControl(false, Validators.required),
                            web: new UntypedFormControl(false, Validators.required),
                        },
                        requireCheckboxesToBeCheckedValidator()
                    ),
                });
            }

            this.onMessageValueChanged(this.communicationForm.get('message').value || '');
        } else {
            // * creating form for system maintenance
            if (this.communication) {
                this.communicationForm = this.formBuilder.group({
                    title: [this.communication?.title, []],
                    message: [this.communication?.message, []],
                    isSystemNotification: [true, []],
                    calender_group: new UntypedFormGroup(
                        {
                            startDate: new UntypedFormControl(this.communication?.startDate, [Validators.required]),
                            endDate: new UntypedFormControl(this.communication?.endDate, [Validators.required]),
                        },
                        CompareDates()
                    ),
                    maintenance_calender_group: new UntypedFormGroup(
                        {
                            startDate: new UntypedFormControl(new Date(this.communication?.systemStartDate), [Validators.required]),
                            endDate: new UntypedFormControl(new Date(this.communication?.systemEndDate), [Validators.required]),
                        },
                        CompareDates()
                    ),
                    checkbox_group: new UntypedFormGroup(
                        {
                            email: new UntypedFormControl(false, Validators.required),
                            mobile: new UntypedFormControl(false, Validators.required),
                            web: new UntypedFormControl(false, Validators.required),
                        },
                        requireCheckboxesToBeCheckedValidator()
                    ),
                });
                if (this.communication?.notificationTypes.length > 0) {
                    this.communication.notificationTypes.forEach((item) => {
                        if (item == CommunicationType.Email) {
                            this.communicationForm.get('checkbox_group').get('email').setValue(true);
                        } else if (item == CommunicationType.Mobile) {
                            this.communicationForm.get('checkbox_group').get('mobile').setValue(true);
                        } else {
                            this.communicationForm.get('checkbox_group').get('web').setValue(true);
                        }
                    });
                }
            } else {
                this.communicationForm = this.formBuilder.group({
                    title: ['', []],
                    message: ['', []],
                    isSystemNotification: [true, []],
                    calender_group: new UntypedFormGroup(
                        {
                            startDate: new UntypedFormControl('', [Validators.required]),
                            endDate: new UntypedFormControl('', [Validators.required]),
                        },
                        CompareDates()
                    ),
                    maintenance_calender_group: new UntypedFormGroup(
                        {
                            startDate: new UntypedFormControl(null, [Validators.required]),
                            endDate: new UntypedFormControl(null, [Validators.required]),
                        },
                        CompareDates()
                    ),
                    checkbox_group: new UntypedFormGroup(
                        {
                            email: new UntypedFormControl(false, Validators.required),
                            mobile: new UntypedFormControl(false, Validators.required),
                            web: new UntypedFormControl(false, Validators.required),
                        },
                        requireCheckboxesToBeCheckedValidator()
                    ),
                });
            }
        }
    }

    // * Add communication
    async saveCommunication(index: number) {
        switch (index) {
            case 0: // * add communication
                this.getFormControlsValue();
                let canCloseAdd = true;
                if (this.preCloseSaveHandler) {
                    try {
                        canCloseAdd = await this.preCloseSaveHandler(this.communicationPayload);
                    } catch (error) {
                        canCloseAdd = false;
                    }
                }
                if (canCloseAdd) {
                    this.activeModel.close(this.communicationPayload);
                }
                break;

            case 1: // * update communication
                this.getFormControlsValue();
                let idx = this.currentCommunicationList.findIndex((item) => item.title == this.communication.title);
                this.communicationPayload.notificationTemplateId = this.communication.notificationTemplateId;
                let saveObj = {
                    communication: this.communicationPayload,
                    index: idx,
                };
                let canCloseUpdate = true;
                if (this.preCloseSaveHandler) {
                    try {
                        canCloseUpdate = await this.preCloseSaveHandler(saveObj);
                    } catch (error) {
                        canCloseUpdate = false;
                    }
                }
                if (canCloseUpdate) {
                    this.activeModel.close(saveObj);
                }
                break;
        }
    }

    // * get form values
    getFormControlsValue() {
        this.communicationPayload = new Communication();
        this.communicationPayload.notificationTypes = [];

        if (!this.communicationForm.get('isSystemNotification').value) {
            this.communicationPayload.isSystemNotification = false;
            this.communicationPayload.title = this.communicationForm.get('title').value;
            this.communicationPayload.message = this.communicationForm.get('message').value || '';
        } else {
            this.communicationPayload.notificationCheckType = 5;
            this.communicationPayload.isSystemNotification = true;
            let maintenanceStartDate = this.communicationForm.get('maintenance_calender_group').get('startDate').value;
            let maintenanceEndDate = this.communicationForm.get('maintenance_calender_group').get('endDate').value;
            this.communicationPayload.systemStartDate = maintenanceStartDate;
            this.communicationPayload.systemEndDate = maintenanceEndDate;
            this.communicationPayload.title = 'IA - System Maintenance!';
            this.communicationPayload.message = `MAINTENANCE: Please be advised that there will be scheduled downtime across our applications from ${new Date(maintenanceStartDate).toLocaleDateString()} to ${new Date(maintenanceEndDate).toLocaleDateString()} for system maintenance. We apologize for any inconvenience.`;
        }

        this.communicationPayload.startDate = this.communicationForm.get('calender_group').get('startDate').value;
        this.communicationPayload.endDate = this.communicationForm.get('calender_group').get('endDate').value;

        if (this.communicationForm.get('checkbox_group').get('email').value) {
            this.communicationPayload.notificationTypes.push(CommunicationType.Email);
        }
        if (this.communicationForm.get('checkbox_group').get('mobile').value) {
            this.communicationPayload.notificationTypes.push(CommunicationType.Mobile);
        }
        if (this.communicationForm.get('checkbox_group').get('web').value) {
            this.communicationPayload.notificationTypes.push(CommunicationType.Web);
        }
    }

    consoleForm() {}

    onKeyPress(event: any) {
        this.customValidator.validateKeyPress(event);
    }

    onMessageValueChanged(value: string) {
        this.characterCount = this.getTextLength(value);
        if (this.characterCount > 150) {
            this.customToastService.errorToast('Maximum 150 characters allowed.');
        }
    }

    getTextLength(text: string): number {
        if (!text) {
            return 0;
        }
        return text.trim().length;
    }
}
